//
// News Load More
//

const timelineBlock = document.querySelectorAll('#pressload .timeline-block');

if (timelineBlock.length > 0) {
    const blockLoadBtn = document.querySelector('#loadMore');
    const blockLength = timelineBlock.length;
    blockLoad = 3;
    if (blockLoad >= blockLength) {
        blockLoadBtn.style.display = 'none';
    }

    timelineBlock.forEach($e => {
        $e.style.display = 'none';
    });

    for (let i = 0; i < blockLoad; i += 1) {
        for (let j = 0; j < timelineBlock.length; j += 1) {
            timelineBlock[i].style.display = 'block';
        }
    }

    blockLoadBtn.addEventListener('click', () => {
        blockLoad = (blockLoad+3 <= blockLength) ? blockLoad+3 : blockLength;
        for (let i = 0; i < blockLoad; i += 1) {
            for (let j = 0; j < timelineBlock.length; j += 1) {
                timelineBlock[i].style.display = 'block';
            }
        }

        if (blockLoad == blockLength) {
            blockLoadBtn.style.display = 'none';
        }
    });
}

